export const initialPaymentsValues = { numberOfPayments: 0, payments: [], total: 0 }
